import axios from "axios";
import querystring from 'querystring'
import {Message} from 'element-ui';
import router from '../router'

// axios.defaults.headers["Content-Type"] = "application/x-www-form-urlencoded";

axios.defaults.headers['Authorization'] = localStorage.getItem("TOKEN") || "";
axios.defaults.headers['language'] = localStorage.getItem("language") || 'CNT'

axios.defaults.headers['area'] = localStorage.getItem("area") || 'HK'
// axios.defaults.headers['area'] = 'HK'


// axios.defaults.headers['platformtype'] = PLATFORM_TYPE;

const service = axios.create({
  // baseURL: process.env.hostAddress, // api的base_url
  baseURL: '', // api的base_url
  // headers:{
  //   "Content-Type":"application/x-www-form-urlencoded"
  // },
  // transformRequest: [
  //   function (data) {
  //     if (data) {
  //       data = querystring.stringify(data);
  //     }
  //     return data;
  //   }
  // ],
  timeout: 100000
});
service.interceptors.request.use(
  config => {
    // config.headers['Content-type'] = 'application/x-www-form-urlencoded;charset=UTF-82';
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    const res = response.data;
    if(res.code === 510){
      localStorage.clear()
      router.push("/login?type=login")
    }
    if (res.code == 200) {
      return res.info || res.data;
    }else if (res.code == 500) {
      Message.error(res.msg);
      return Promise.reject(res);
    } else {
      return Promise.reject(res);
    }

    // if (res.code !== 200) {
    //   return Promise.reject(res);
    // } else {
    //   return res.info || res.data;
    // }
  },
  error => {
    return Promise.reject(error);
  }
);

function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

export default service;

// export function post(url, data, config) {
//   return axios.post(baseURL + url, data, config);
// }



// WEBPACK FOOTER //
// ./src/utils/request.js